import { useTranslations } from "next-intl"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { useFormatSupplyPointMarketName } from "./useFormatSupplyPointMarketName"

const graphQLFragments = {
    supplyPoint: graphql(
        `
            fragment useFormatSupplyPointName_SupplyPoint on SupplyPointType {
                ...useFormatSupplyPointMarketName_SupplyPoint
            }
        `,
        [useFormatSupplyPointMarketName.fragments.supplyPoint]
    ),
}

export function useFormatSupplyPointName() {
    const t = useTranslations("useFormatSupplyPointName")
    const formatMarketName = useFormatSupplyPointMarketName()

    return (supplyPointFragment: FragmentOf<typeof graphQLFragments.supplyPoint> | null) => {
        const supplyPoint = readFragment(graphQLFragments.supplyPoint, supplyPointFragment)

        if (!supplyPoint) {
            return null
        }

        return t(`name`, {
            marketName: formatMarketName(supplyPoint),
        })
    }
}

useFormatSupplyPointName.messages = [
    "useFormatSupplyPointName",
    ...useFormatSupplyPointMarketName.messages,
] as const

useFormatSupplyPointName.fragments = graphQLFragments
